export enum UserTip {
    ADD_COMMENT = 'addComment',
    LINK_PRODUCT = 'linkProduct',
    INVITE_COLLABORATOR = 'inviteCollaborator',
    DOWNLOAD_IMAGE = 'downloadImage',
    COMPANY_SIGNUP = 'companySignup',
    RESIZE_COMPONENT = 'resizeComponent',
}

export type UserTipType = keyof typeof UserTip;

export type UserTipFormatter = {
    name: UserTip;
    icon?: React.ReactNode;
    title: string;
    description: React.ReactNode;
};
